import { render } from "./Panchang.vue?vue&type=template&id=4218c73e&scoped=true"
import script from "./Panchang.vue?vue&type=script&lang=js"
export * from "./Panchang.vue?vue&type=script&lang=js"

import "./Panchang.vue?vue&type=style&index=0&id=4218c73e&scoped=true&lang=css"

import exportComponent from "C:\\TK\\LivppyLab\\LivppyLab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4218c73e"]])

export default __exports__